//import * as log from '../common/js/appLogger'
import * as util from '../common/js/util';
import { ASession } from '../model/common/ASession';

export class AppStatus extends ASession {
	protected sessionKey: string = 'AppStatus';

	protected debugMode: boolean = false;
	protected app?: string;
	protected appVersion?: string;

	protected errorPromptData: any;

	constructor() {
		super();
		this.setData(this.getDefaultData());
	}

	protected getDefaultData(): any {
		return {
			debugMode: false,
			app: null,
			appVersion: null,
			errorPromptData: {
				errorPromptShow: false,
				errorPromptDesc: '',
				errorPromptTitle: '',
				errorPromptCloseBtnText: {},
			},
		};
	}

	protected getData(): any {
		return {
			debugMode: this.debugMode,
			app: this.app,
			appVersion: this.appVersion,
			errorPromptData: this.errorPromptData,
		};
	}
	protected setData(data: any) {
		this.debugMode = data.debugMode ?? false;
		this.app = data.app;
		this.appVersion = data.appVersion;

		var promptData = data.errorPromptData ?? {};
		this.errorPromptData = {
			errorPromptShow: promptData.errorPromptShow ?? false,
			errorPromptDesc: promptData.errorPromptDesc ?? '',
			errorPromptTitle: promptData.errorPromptTitle ?? '',
			errorPromptCloseBtnText: promptData.errorPromptCloseBtnText ?? {},
		};

		//dont add save() here.
	}

	//override
	public load() {
		super.load();

		var params: any = util.getUrlVars(null);

		//priority: URL param > session
		// eslint-disable-next-line eqeqeq
		var paramMode = params['debug'] && params['debug'] == 'Y';
		if (paramMode) {
			this.debugMode = paramMode;
		}
		var app: string = params['app'];
		if (app) {
			this.app = app;
		}

		var appVersion: string = params['appVersion'];
		if (appVersion) {
			this.appVersion = appVersion;
		}
		this.logi('override by URL param');
		this.save();
	}

	public isDebugMode(): boolean {
		return this.debugMode ? true : false;
	}

	public getAppVersion(): string | null {
		return this.appVersion ? this.appVersion + '' : null;
	}

	public getErrorPromptInfo(): any {
		return Object.assign({}, this.errorPromptData);
	}

	public setErrorPromptInfo(info: any) {
		this.errorPromptData = {
			errorPromptShow: info.errorPromptShow ?? false,
			errorPromptDesc: info.errorPromptDesc ?? '',
			errorPromptTitle: info.errorPromptTitle ?? '',
			errorPromptCloseBtnText: info.errorPromptCloseBtnText ?? {},
		};
		this.save();
	}
}
